import React from 'react';
import { Row, Col, Card, Typography } from 'antd';

const { Text } = Typography;

/**
 * Component to display summary statistics cards
 * @param {Object} props - Component props
 * @param {Object} props.summaryStats - Statistics to display
 * @returns {JSX.Element} Summary statistics cards
 */
const SummaryStatisticsCards = ({ summaryStats }) => {
  return (
    <Row gutter={16} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">Total Customers</Text>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {summaryStats?.totalCustomers?.toLocaleString() || 0}
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">Total Sales</Text>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              ${summaryStats?.totalSales?.toLocaleString(undefined, {maximumFractionDigits: 0}) || 0}
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">Total Orders</Text>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {summaryStats?.totalOrders?.toLocaleString() || 0}
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Card>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">Orders per Customer</Text>
            <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {summaryStats?.ordersPerCustomer?.toFixed(1) || 0}
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default SummaryStatisticsCards;
